import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";

import CurrentOffers from "./CurrentOffers/CurrentOffers.js";
import ExpiredOffers from "./ExpiredOffers/ExpiredOffers.js";
import Button from "../../Buttons/Button";
import TopNav from "../../TopNav/TopNav";
import SideBar from "../../SideBar/SideBar";
import { Tab, TabsContainer } from "../../../utils/tab";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  white-space: nowrap;
  padding: 20px 0;

  > h1 {
    font-size: 2rem;
    font-weight: 400;
    color: #ffffff;
    width: 50%;
  }

  > div {
    width: max-content;
  }
`;

const EmptyStateWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 60px 20px;
  text-align: center;
  color: #ccc;

  svg {
    font-size: 80px;
    color: #888;
  }

  h3 {
    font-size: 1.5rem;
    font-weight: 500;
    color: #fff;
  }

  p {
    max-width: 400px;
    font-size: 1rem;
    color: #aaa;
  }
`;

const EmptyState = ({ title, message }) => (
    <EmptyStateWrapper
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
    >
      <Icon icon="solar:box-bold-duotone" />
      <h3>{title}</h3>
      <p>{message}</p>
    </EmptyStateWrapper>
);

const ListOffers = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("current");

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };


  return (
      <main>
        <TopNav />
        <div className="main-container">
          <SideBar />

          <article
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                overflow: "hidden",
              }}
          >
            <section className="moderators" style={{ width: "100%", maxWidth: "1550px" }}>
              <Container>
                <ContainerHeader>
                  <h1>Offers</h1>
                  <div className="d-flex align-items-center ms-auto flex-wrap gap-2">
                    <Button
                        primaryBtn
                        onClick={() => navigate("/offers/new")}
                        iconifyIconName="solar:letter-outline"
                    >
                      Create offer
                    </Button>
                  </div>
                </ContainerHeader>

                <div>
                  <TabsContainer>
                    <Tab
                        active={activeTab === "current"}
                        onClick={() => handleTabClick("current")}
                    >
                      <p>Current Offers</p>
                    </Tab>
                    <Tab
                        active={activeTab === "expired"}
                        onClick={() => handleTabClick("expired")}
                    >
                      <p>Expired Offers</p>
                    </Tab>
                  </TabsContainer>

                  {activeTab === "current" && <CurrentOffers />}
                  {activeTab === "expired" && <ExpiredOffers />}
                </div>
              </Container>
            </section>
          </article>
        </div>
      </main>
  );

};

export default ListOffers;
